import { create } from 'zustand';
import * as api from '../api/endpoints';

export interface AuthUser {
  id: number;
  username: string;
  role: 'owner' | 'annotator';
}

interface AuthState {
  user: AuthUser | null;
  loading: boolean;

  checkAuth: () => Promise<boolean>;
  login: (username: string, password: string) => Promise<AuthUser>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,

  checkAuth: async () => {
    set({ loading: true });
    try {
      const res = await fetch('/api/auth/me');
      if (res.ok) {
        const user = await res.json();
        set({ user, loading: false });
        return true;
      }
      set({ user: null, loading: false });
      return false;
    } catch {
      set({ user: null, loading: false });
      return false;
    }
  },

  login: async (username: string, password: string) => {
    const res = await api.authLogin(username, password);
    if (!res) throw new Error('Invalid credentials');
    set({ user: res.user });
    return res.user;
  },

  logout: async () => {
    try {
      await api.authLogout();
    } catch {
      // ignore
    }
    set({ user: null });
  },
}));
